import React from "react";
import { MdOutlineStarBorder } from "react-icons/md";

import { getGradeBackgroundColor } from "../../../utils/colorUtils";

const AStarGradeDisplay = ({ grade = -1 }) => {
  const normalizedGrade = Math.round((grade + Number.EPSILON) * 10) / 10 || -1;
  const isNA = normalizedGrade === -1;
  const gradeBgColor = isNA
    ? "bg-[#e5e7eb] text-[#737373]"
    : getGradeBackgroundColor(normalizedGrade);

  return (
    <div className="bg-white rounded-md star-display__wrapper">
      <div
        className={`flex justify-start items-center font-semibold text-center px-[8px] py-[4px] rounded-md text-xs ${gradeBgColor}`}
      >
        <MdOutlineStarBorder size={20} />
        <span className="mx-[4px]">{isNA ? "N.A" : normalizedGrade}</span>
      </div>
    </div>
  );
};

export default AStarGradeDisplay;
